import CustomStore from 'devextreme/data/custom_store';
import { app } from '../main';
import serializeFilter from './serialize-filter';

export default url => {
  const store = new CustomStore({
    key: 'id',
    paginate: true,
    load: async loadOptions => {
      const params = {};

      if (loadOptions.sort) {
        params.ordering = loadOptions.sort.map(x => (x.desc ? '-' : '') + x.selector).join(',');
      }
      if (loadOptions.take) {
        params.skip = loadOptions.skip;
        params.take = loadOptions.take;
      }
      if (loadOptions.filter) {
        params.filters = serializeFilter(loadOptions.filter, loadOptions.dataField);
      }
      if (loadOptions.searchValue) {
        params.search = loadOptions.searchValue;
      }

      const { results, count } = await app.$http.get(url, { params });
      return {
        data: results,
        totalCount: count,
      };
    },
    update: async (key, values) => {
      values.id = key;

      const { results, count } = await app.$http.patch(`${url}${values.id}/`, values);
      return {
        data: results,
        totalCount: count,
      };
    },
    insert: async values => {
      const { results, count } = await app.$http.post(url, values);
      return {
        data: results,
        totalCount: count,
      };
    },
    byKey: key => {
      return app.$http.get(`${url}${key}/`);
    },
    remove: key => {
      return app.$http.delete(`${url}${key}/`);
    },
  });
  return store;
};
